import { useCallback, useMemo, useState } from 'react';
import cls from 'classnames';
import styles from './index.module.scss';
export default (props: Record<string, any>) => {
  const { types = [] } = props;
  const gotoDetail = useCallback((item: any) => {
    if (item?.redirectUrl) {
      window.open(item?.redirectUrl);
    }
  }, []);
  const content: any = useMemo(() => {
    let childrenArra: any = [];
    const nodeArra: any = [];
    types.forEach((item: any, index: number) => {
      childrenArra.push(
        <div className={styles['type-item']} key={item.title}>
          <div className={cls(styles['type-inner'])} onClick={() => gotoDetail(item)}>
            <img src={item.url} />
            <p>{item.title}</p>
          </div>
        </div>
      );
      if ((index + 1) % 7 === 0 || index === types.length - 1) {
        nodeArra.push(<div className={cls(styles['types-area-inner'], 'flex', 'v-center')}>{childrenArra}</div>);
        childrenArra = [];
      }
    });
    return nodeArra;
  }, [types]);
  return <div className={cls(styles['types-area'])}>{content}</div>;
};
